import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProactiveSupportSensorDetailsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proactive-support-sensor-details',
	path: '/jira/servicedesk/projects/:projectKey/settings/proactive-support/sensor/:sensorId',
	exact: true,
};
